import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ConsultingIncomeReport } from "models/consulting-income"
import Branch from "models/branch"

export interface ConsultingIncomeSliceState {
    report: ConsultingIncomeReport
    branches: Branch[]
}

export const initialState: ConsultingIncomeSliceState = {
    report: { departments: [], divisions: [] },
    branches: [],
}

const consultingIncomeSlice = createSlice({
    name: 'consultingIncome',
    initialState,
    reducers: {
        setReport(state, { payload }: PayloadAction<ConsultingIncomeReport>) {
            state.report = payload
        },
        setBranches(state, { payload }: PayloadAction<Branch[]>) {
            state.branches = payload
        },
    }
})

export const {
    setReport,
    setBranches,
} = consultingIncomeSlice.actions

export default consultingIncomeSlice.reducer
